export default __webpack_public_path__ + "static/media/supportNote.4131ead0.svg";